import React, { useEffect, useState } from 'react';
import Form from "react-bootstrap/Form";
import { patterns, useForm } from "../../helpers/useForm";
import { http } from "../../helpers/http";
import Auth from "../../auth/Auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import { Modal } from "react-bootstrap";
import { clearCart } from '../../helpers/help';
const EditProfile = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [picture, setPicture] = useState();
    //used to set location dropdown
    const [location, setLocation] = useState([]);


    const [selectedLocation, setSelectedLocation] = useState('');
    const [originalLocation, setOriginalLocation] = useState('');
    const [modal, setModal] = useState(false);

    const onChangePicture = e => {

        const file = e.target.files[0];
        setPicture({
            url: URL.createObjectURL(file),
            file: file
        });

    };


    const { values, errors, bindField, isValid, setInitialValues } = useForm({
        validations: {
            userName: {
                required: true,
            },
            email: {
                pattern: {
                    value: patterns.email,
                    message: "Invalid email address.",
                },
                required: true,
            },
            mobileNumber: {
                required: true,
            },
            located_at: {
                required: true
            },
            file: {
                // required: true,
            }
        },
    });
    const getCheckoutProfile = () => {
        // dispatch(updateFullScreenLoader(true));
        http(
            {
                method: "GET",
                url: `getProfile`,
                isSecure: true,
            },
            (res) => {
                setInitialValues(res.usersDetails);
                setPicture({
                    url: res?.usersDetails?.image
                })
                setSelectedLocation(res?.usersDetails?.located_at);
                setOriginalLocation(res?.usersDetails?.located_at);
                // dispatch(updateFullScreenLoader(false));
            }
        );
    };


    const handleYesButtonClick = () => {
        setOriginalLocation(selectedLocation);
        setModal(false); // Close the modal
        submitProfile(selectedLocation, 'yes');

    }

    const handleNoButtonClick = () => {
        console.log('originalLocation', originalLocation, 'selectedLocation', selectedLocation);
        setSelectedLocation(originalLocation);
        setModal(false); // Close the modal
        submitProfile(originalLocation, 'no');
    }


    //for getting location 
    function locationDropdown() {
        http(
            {
                method: "get",
                url: "getloginSetting",
                isSecure: true
            },
            (response) => {
                setLocation(response.located_at);
            }, (error) => {
                toast.error(error.errorMessage);
            })
    }

    useEffect(() => {
        if (!Auth.isUserAuthenticated()) {
            navigate("/");
            return;
        }
        locationDropdown();
        getCheckoutProfile();
    }, []);


    const submitProfile = (location, type) => {
        dispatch(updateFullScreenLoader(true));
        const formData = new FormData();
        console.log('originalLocation', originalLocation, 'selectedLocation', selectedLocation, 'location', location);

        if (picture.file) {
            formData.append('image', picture.file);
        }
        formData.append('userName', values?.userName);
        formData.append('located_at', location);
        formData.append('email', values?.email);
        formData.append('countryCode', JSON.parse(sessionStorage.getItem("__takk_out"))?.countryCode);
        formData.append('mobileNumber', values?.mobileNumber);
        formData.append('short_interest_survey', values?.short_interest_survey && values?.short_interest_survey === "null" ? "" : values?.short_interest_survey);
        http(

            {
                method: "POST",
                url: "updateProfile",
                isSecure: true,
                contentType: "multipart/form-data",
                body: formData

            },
            (res) => {
                if (res.error === "false") {
                    console.log('selected', selectedLocation);
                    // if (JSON.parse(sessionStorage.getItem("__takk_out"))?.located_at !== selectedLocation) {
                    // clearCart();
                    // }
                    if (type === 'yes') {
                        clearCart();
                        let value = { 'located_at': selectedLocation }
                        let prevData = JSON.parse(sessionStorage.getItem("__takk_out"));
                        Object.keys(value).forEach(function (val, key) {
                            prevData[val] = value[val]
                        })
                        console.log('prevData', prevData);
                        sessionStorage.setItem('__takk_out', JSON.stringify(prevData));
                        sessionStorage.setItem('_current_location', selectedLocation);
                    }

                    toast.success(res.errorMessage);
                    navigate("/profile")
                }

                dispatch(updateFullScreenLoader(false));
            }
        )

    }

    const userUpdateProfile = (event) => {
        event.preventDefault();
        console.log('originalLocation', originalLocation, 'selectedLocation', selectedLocation);
        if (originalLocation !== selectedLocation) {
            setModal(true); // Open the modal
        } else {
            submitProfile(JSON.parse(sessionStorage.getItem("__takk_out"))?.located_at, 'no');
        }

    }
    // const goToUserProfile = () => {
    //     navigate("/profile")
    // }


    return (
        <>
            {/* <main>
                <div className="restaurant_inner_bg needmin-hmain">
                    <div className="cus_container">
                        <h1 className="head1 text-center">Edit Profile</h1>
                    </div>
                </div>
            </main> */}
            <section className="EditProfile_section">
                <Form onSubmit={userUpdateProfile}>
                    <div className="cus_container">
                        <div className="head4">Edit Profile</div>

                        <div className="d-flex mt-4 justify-content-between"></div>

                        <div className="col-left">
                            <div className="white_box p-sm-4 py-4 px-2">
                                <div className='upload-file mb-sm-5 mb-4'>
                                    <label htmlFor="upload" className="upload_file position-relative">
                                        <input
                                            type="file"
                                            name="image"
                                            // placeholder=''
                                            accept="image/png, image/gif, image/jpeg"
                                            {...bindField("file")}
                                            className="upload_file_file"
                                            onChange={onChangePicture}
                                        />
                                        {picture?.url ? <img className="playerProfilePic_home_tile" src={picture?.url} /> : <img src="./assets/img/Boomerang.png" alt="" className='profileIcon' />}
                                        <img
                                            src="./assets/img/camera.svg"
                                            alt=""
                                            className='camera'
                                        />

                                    </label>
                                    {picture?.url === null && (
                                        <p className="text-danger err small mt-3">
                                            Please Select Profile Image
                                        </p>
                                    )}
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-grbox">
                                            <label className="blackC">
                                                Name<sup>*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                name="userName"
                                                {...bindField("userName")}
                                                className="input_control"
                                                placeholder="Enter the Name"
                                            />
                                        </div>
                                        {errors.userName && (
                                            <span className="text-danger err small">
                                                {errors.userName}
                                            </span>
                                        )}

                                    </div>
                                    <div className="col-md-6 mt-3 mt-md-0">
                                        <div className="input-grbox">
                                            <label className="blackC">
                                                Email<sup>*</sup>
                                            </label>
                                            <input
                                                type="email"
                                                {...bindField("email")}
                                                name="email"
                                                className="input_control"
                                                placeholder="Enter the Email"
                                                disabled

                                            />
                                        </div>
                                        {errors?.email && (
                                            <span className="text-danger err small">
                                                {errors?.email}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="row mt-md-4 mt-3">
                                    <div className="col-md-6 ">
                                        <div className="input-grbox">
                                            <label className="blackC">
                                                Phone Number<sup>*</sup>
                                            </label>
                                            <input
                                                type="number"
                                                className="input_control"
                                                name="mobileNumber"
                                                maxLength={10}
                                                {...bindField("mobileNumber")}
                                                placeholder="Enter the Phone Number"
                                                disabled
                                            />
                                        </div>
                                        {errors?.mobileNumber && (
                                            <span className="text-danger err small">
                                                {errors?.mobileNumber}
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-md-6 mt-3 mt-md-0">
                                        <div className="input-grbox ">
                                            <label className="blackC" htmlFor="">Location<sup>*</sup></label>
                                            {/* <select
                                                {...bindField("located_at")}
                                                className="input_control loctSelect"
                                                value={values?.located_at}
                                                defaultValue=""
                                            >
                                                <option value="" disabled>Select Location</option>
                                                {location.map((area, index) => index > 0 && <option key={area.id} value={area.name}>{area.displayName}</option>)}
                                            </select> */}


                                            <select
                                                {...bindField("located_at")}
                                                className="input_control loctSelect"
                                                value={selectedLocation}
                                                onChange={(e) => {
                                                    setSelectedLocation(e.target.value);

                                                }}
                                                defaultValue=""
                                            >
                                                <option value="" disabled>Select Location</option>
                                                {location.map((area, index) => index > 0 && <option key={area.id} value={area.name}>{area.displayName}</option>)}
                                            </select>


                                        </div>
                                        {errors?.located_at && (
                                            <span className="text-danger err small">
                                                {errors?.located_at}
                                            </span>
                                        )}
                                    </div>





                                </div>

                                <div className="row mt-md-4 mt-3">
                                    <div className="col-md-6">
                                        <div className="input-grbox">
                                            <label className="blackC">
                                                Short Interests Survey (Optional)
                                            </label>
                                            <input
                                                type="text"
                                                className="input_control"
                                                name="short_interest_survey"
                                                {...bindField("short_interest_survey")}
                                                placeholder="Enter Your Interests Survey"
                                            />
                                        </div>
                                        {/* {errors?.mobileNumber && (
                                            <span className="text-danger err small">
                                                {errors?.mobileNumber}
                                            </span>
                                        )} */}
                                    </div>
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="cusbtn btnsize17 mt-4"
                                // disabled={!(isValid() && errors && !(picture?.url === null))}
                                disabled={!isValid()}
                            // onClick={goToUserProfile}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </Form>
                <Modal
                    show={modal}
                    onHide={() => setModal(false)}
                    centered
                    className="logoutmodal center-close-icon"
                >
                    {/* <Modal.Header closeButton></Modal.Header> */}
                    <div className="bodyModal">
                        <p className="txt text-center mb-2">Your last selected location is <h4 className="font-bold text-center">{sessionStorage.getItem("_current_location") == 'st_thomas' ? 'St. Thomas' : 'St. Croix'}</h4> Do you want to switch? If yes your cart will be cleared.</p>
                        <div className="footerM text-center mt-4">
                            <button
                                className="cusbtn me-3 minonehunt"
                                onClick={handleYesButtonClick}
                            >
                                Yes, Switch Location
                            </button>
                            <button
                                className="hoverbtn minonehunt"
                                onClick={handleNoButtonClick}
                            >
                                Don't Switch
                            </button>
                        </div>
                    </div>
                </Modal>
            </section>
        </>
    );
};

export default EditProfile;
